import throttle from 'lodash/throttle'
import { useEffect, useState } from 'react'

export const useMatchMedia = (query: string) => {
    const [matches, setMatches] = useState(window?.matchMedia(query).matches)
    useEffect(() => {
        const handler = () => setMatches(window?.matchMedia(query).matches)
        const perfHandler = throttle(handler, 500)
        window?.addEventListener('resize', perfHandler)
        return () => window?.removeEventListener('resize', perfHandler)
    }, [query])
    return matches
}
